module.exports = "/assets/374aedfa9b7b3d1f16d2b458f6db51b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/HD.png
// module id = 1436
// module chunks = 0